<template>
  <!-- Use custom modal for fullscreen support instead of dc-modal with portal -->
  <transition name="modal-fade">
    <div v-if="showDialog" class="modal-overlay" :class="{ 'map-modal': isFullscreen }" @click="handleCancel">
      <div class="modal-dialog" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fa fa-exclamation-triangle text-warning"></i>
            Unsaved Changes
          </h4>
          <button class="close-btn" @click="handleCancel">
            <i class="fa fa-times"></i>
          </button>
        </div>
        
        <div class="modal-body">
          <p>You have unsaved changes to your service areas.</p>
          <p><strong>What would you like to do?</strong></p>
          <ul class="options-list">
            <li><strong>Revert Changes:</strong> Discard all unsaved changes and return to the last saved state</li>
            <li><strong>Keep Editing:</strong> Continue editing with your current changes</li>
          </ul>
        </div>
        
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            @click="handleDiscard"
            :disabled="saving"
          >
            <i class="fa fa-undo"></i>
            Revert Changes
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleCancel"
            :disabled="saving"
          >
            <i class="fa fa-edit"></i>
            Keep Editing
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UnsavedChangesDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleDiscard() {
      this.$emit('discard');
    },

    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* When inside the map container (for fullscreen support) */
.modal-overlay.map-modal {
  position: absolute;
  z-index: 2000;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  margin: 10px 0;
}

.options-list {
  margin: 15px 0;
  padding-left: 20px;
}

.options-list li {
  margin: 8px 0;
  line-height: 1.4;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #218838;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #0069d9;
}

.btn-default {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}

.btn-default:hover:not(:disabled) {
  background: #e8e8e8;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.text-warning {
  color: #f0ad4e;
  margin-right: 8px;
}

/* Modal animation */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-dialog,
.modal-fade-leave-active .modal-dialog {
  transition: transform 0.3s;
}

.modal-fade-enter .modal-dialog,
.modal-fade-leave-to .modal-dialog {
  transform: scale(0.9);
}
</style>